import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';

export const FILE_CREDIT_NOTE = 'Reading files, generating code, and additional steps can increase the total.';

const styles = StyleSheet.create({
  container: { paddingHorizontal: 14, paddingTop: 6, paddingBottom: 4 },
});

export default function ChatInputCreditNote() {
  return (
    <View style={styles.container}>
      <Text size="xs" color="secondary">{FILE_CREDIT_NOTE}</Text>
    </View>
  );
}
